var React = require('react');

function CircleLinkInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"18","fill":"#00114D","key":0}),React.createElement("path",{"d":"m25.038 10.602-8.361 8.42M26 21.429v3.188c0 .781-.662 1.383-1.384 1.383H11.384C10.6 26 10 25.338 10 24.616V11.384c0-.722.662-1.384 1.383-1.384h3.188M19.263 10.12l5.895-.12c.24 0 .481.24.481.541l-.12 5.835","stroke":"#fff","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":1})]);
}

CircleLinkInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CircleLinkInline;

CircleLinkInline.default = CircleLinkInline;
